import PromotionDiscussionPage from "../../promotion/PromotionDiscussionPage";

const PromoDiscussionDetail = ({ backPath = "/customer/promotions" }) => {
  return <PromotionDiscussionPage back={backPath} />;
};

export default PromoDiscussionDetail;
